import { render, staticRenderFns } from "./approvalManagement.vue?vue&type=template&id=d78ad460&scoped=true"
import script from "./approvalManagement.vue?vue&type=script&lang=js"
export * from "./approvalManagement.vue?vue&type=script&lang=js"
import style0 from "./approvalManagement.vue?vue&type=style&index=0&id=d78ad460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78ad460",
  null
  
)

export default component.exports